import React, { useState } from "react";
import { useSelector } from "react-redux";

const toTitleCase = (str) =>
  str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));

const ManualGrid = () => {
  const { selectedTournament } = useSelector((state) => state.tournament);
  const cat1 = selectedTournament?.categories?.[0]?.label || "";

  const [selectedCategory, setSelectedCategory] = useState(cat1);

  return (
  <div className="members-container">
    <h3>Format</h3>
    <div className="sub-header">
          {selectedTournament?.categories && (
            <div className="category-filters">
              {selectedTournament.categories.map((category) => (
                <button
                  key={category._id}
                  className={`category-filter ${selectedCategory === category.label ? "active" : ""}`}
                  onClick={() => setSelectedCategory(category.label)}
                >
                  {toTitleCase(category.label)}
                </button>
              ))}
            </div>
          )}
        </div>

    <div className="phase-box">
        <p>Phase 1</p>
        <h3>Create from scratch</h3>
        <span>Customize the tournament to suit your needs — add stages, set rules, and build a unique structure without restrictions.</span>
    </div>

  </div>
  )
};

export default ManualGrid;
